import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardBody, CardHeader, CardTitle } from "@jotty/ui";
export const Route = createFileRoute("/_authed/meetings/new")({
  component: NewMeeting,
});
function NewMeeting() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Start a meeting in Jotty for Mac</CardTitle>
      </CardHeader>
      <CardBody>
        <p>
          Open Jotty on your Mac, create a note, and start capture when everyone
          is ready. Your notes sync here after capture. No bot joins your
          meeting.
        </p>
        <p>
          <a href="jotty://settings/callback">Open Jotty for Mac</a>
        </p>
        <Link to="/meetings">Back to meetings</Link>
      </CardBody>
    </Card>
  );
}
